import { render, staticRenderFns } from "./PurchaseSuccess.vue?vue&type=template&id=79fdda98&"
import script from "./PurchaseSuccess.vue?vue&type=script&lang=js&"
export * from "./PurchaseSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports